import {Form, useActionData, useLocation} from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormControl from "react-bootstrap/FormControl";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";
import {LoginWithGoogleButton} from "../../components/LoginWithGoogleButton";

export function RegisterPage() {
    let location = useLocation();
    let params = new URLSearchParams(location.search);
    let from = params.get("from") || "/";

    let actionData = useActionData();

    return (
        <Row className="login">
            <Col xs={12} sm={6} className="mx-auto mt-5 p-5 shadow-sm">
                <Form method="post" replace>
                    <FormControl hidden={true} name="redirectTo" value={from}/>
                    <Row className="pb-3">
                        <Col xs={6}>
                            <FormControl required={true} name="firstName" type="text" placeholder="first name"/>
                        </Col>
                        <Col xs={6}>
                            <FormControl required={true} name="lastName" type="text" placeholder="last name"/>
                        </Col>
                    </Row>
                    <Row>
                        <Stack direction="vertical" gap={3}>
                            <FormControl required={true} name="email" type="email" placeholder="email"/>
                            <FormControl required={true} name="password" type="password" placeholder="password"/>
                            <FormControl required={true} name="description" placeholder="provide your club title"/>
                            <Button type="submit" variant="outline-success">Register</Button>
                            <LoginWithGoogleButton/>
                        </Stack>
                    </Row>
                    {actionData && actionData.error
                        ?
                        <Row className="pt-3"><Col xs={12}><p className="text-danger">{actionData.error}</p></Col></Row>
                        : <></>
                    }
                </Form>
            </Col>
        </Row>
    );
}